import { render, staticRenderFns } from "./NavbarToggleButton.vue?vue&type=template&id=4481f42a&"
import script from "./NavbarToggleButton.vue?vue&type=script&lang=js&"
export * from "./NavbarToggleButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports